var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 117,
    rx: 58.5,
    fill: "#99B1DB",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6625 88.1875H73.3375V77.4719C73.3375 73.5344 72.0016 70.1453 69.3297 67.3047C66.6578 64.4641 63.3813 63.0438 59.5 63.0438C55.6187 63.0438 52.3422 64.4641 49.6703 67.3047C46.9984 70.1453 45.6625 73.5344 45.6625 77.4719V88.1875ZM59.5 55.9563C63.3813 55.9563 66.6578 54.5359 69.3297 51.6953C72.0016 48.8547 73.3375 45.4375 73.3375 41.4438V30.8125H45.6625V41.4438C45.6625 45.4375 46.9984 48.8547 49.6703 51.6953C52.3422 54.5359 55.6187 55.9563 59.5 55.9563ZM32.5 93.25V88.1875H40.6V77.4719C40.6 73.5344 41.6266 69.9203 43.6797 66.6297C45.7328 63.3391 48.5875 60.9625 52.2438 59.5C48.5875 58.0375 45.7328 55.6469 43.6797 52.3281C41.6266 49.0094 40.6 45.3813 40.6 41.4438V30.8125H32.5V25.75H86.5V30.8125H78.4V41.4438C78.4 45.3813 77.3734 49.0094 75.3203 52.3281C73.2672 55.6469 70.4125 58.0375 66.7562 59.5C70.4125 60.9625 73.2672 63.3391 75.3203 66.6297C77.3734 69.9203 78.4 73.5344 78.4 77.4719V88.1875H86.5V93.25H32.5Z",
    fill: "#003CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.588a7fa7f6bab0c0368215566b41db00.svg";
export { ForwardRef as ReactComponent };